import Vue from "vue";
import auth from "@/auth/auth.js";
import VueCookie from "vue-cookie";
import router from "@/router/index";

const state = {
  user: {},
  token: null
};

const getters = {
  IS_LOGGED_IN(state) {
    return state.token == null ? false : true;
  }
};

const actions = {
  LOGIN: function({ commit }, payload) {
    return Vue.prototype.$axios
      .post(
        "/auth/token",
        {},
        {
          auth: {
            username: payload.email,
            password: payload.password
          }
        }
      )
      .then(
        response => {
          auth.setToken(response.data.token, response.data.expiry).then(() => {
            if (auth.tokenIsValid(response.data.token)) {
              VueCookie.set("token", response.data.token);
              Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${VueCookie.get(
                "token"
              )}`;
              commit("SET_USER", auth.decodeToken(response.data.token));
              commit("SET_TOKEN", response.data.token);
              if (router.currentRoute.query.redirect) {
                router.push(router.currentRoute.query.redirect);
              } else {
                router.push({ name: "Account" });
              }
              return response;
            }
            throw new Error("Token is invalid");
          });
        },
        err => {
          throw new Error(err);
        }
      );
  },
  SIGNUP: async function(context, payload) {
    return Vue.prototype.$axios.post("/users", payload).then(
      () => {},
      err => {
        throw new Error(err);
      }
    );
  },
  SIGNUP_SURGERY: async function(context, payload) {
    return Vue.prototype.$axios.post("/users/surgeries/register", payload).then(
      () => {},
      err => {
        throw new Error(err);
      }
    );
  },
  RESET_PASSWORD_EMAIL: async function(context, payload) {
    return await Vue.prototype.$axios.post("/auth/password/email", payload);
  },
  RESET_PASSWORD: async function(context, payload) {
    return await Vue.prototype.$axios.post(
      "/auth/password/reset/" + payload.id,
      payload
    );
  },
  CHANGE_PASSWORD: async function({ state }, payload) {
    return await Vue.prototype.$axios
      .post("users/" + state.user.uid + "/password", payload)
      .then(
        () => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  },
  LOGOUT: async function({ state }) {
    state.token = null
    state.user = null
    VueCookie.delete('token');
  } 
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
